export default "__VITE_ASSET__B4teGB8J__"